import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { StationService } from 'src/app/api/station.service';
import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-communaute',
  templateUrl: './communaute.component.html',
  styleUrls: ['./communaute.component.scss'],
  animations: [
    trigger('flipState', [
      state('active', style({
        transform: 'rotateY(179deg)'
      })),
      state('inactive', style({
        transform: 'rotateY(0)'
      })),
      transition('active => inactive', animate('500ms ease-out')),
      transition('inactive => active', animate('500ms ease-in'))
    ])
  ]
})
export class CommunauteComponent implements OnInit {

  constructor(private StationService: StationService, public sanitizer : DomSanitizer) { }

  ngOnInit(): void {
    this.subscribeToCommunautes()
  }

  members : any;
  IsWait: boolean = true;


 
 


subscribeToCommunautes(){
  this.StationService.getCommunautes().subscribe(
    data => {
    console.log(data)
    this.IsWait = false;
    this.members = data.data.sort((a,b) => a.index - b.index)
    },
    err => {
      console.log(err)
    });
  }



  sanitizeImageUrl(imageUrl: any): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
}


subscribeLink(link : string){
  window.location.href = link;
}




}
